import * as nav from "./nav.js";
import * as page from "./page.js";

jQuery(window).on("load", function () {
  console.log("critical load");
  page.init();
  nav.init();
});
